import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthDialogService } from 'src/app/shared/services/auth-dialog.service';
import { firstValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const authDialogService = inject(AuthDialogService);
  const router = inject(Router);

  const loggedIn = await firstValueFrom(authService.isLoggedIn());

  if (loggedIn) {
    return true;
  }

  // Open Auth Modal in place
  const loginSuccess = await firstValueFrom(authDialogService.openAuthDialog('login'));
  if (loginSuccess) {
    return true;
  } else {
    // If user closed dialog without logging in, redirect to home if initial navigation
    if (!router.navigated) {
      return router.createUrlTree(['/']);
    }
    return false;
  }
};

